module.exports = __webpack_public_path__ + "a99abd2ed8729acbb4064378094a5ffc.png";